<template>
  <div class="bg-white header">
    <div class="ls-flex-center">
      <div class="max-width">
        <div class="flex align-center" style="padding: 1rem 0;">
          <div style="width: 72%;">
            <img src="../assets/logo.png" alt="" style="width: 7rem;height: 1.9rem;">
          </div>
          <div class="flex align-center flex-between">
            <div class="flex align-center pointer"  @click="show = true" style="background: #F5F5F5;border-radius: 2rem;padding: 0.4rem 1rem;margin-right: 1rem;">
              <img src="../assets/local.png" alt="" style="width: 1.3rem;height: 1.3rem;">
              <div>太原市</div>
              <i class="el-icon-arrow-down"></i>
            </div>
            <div class="show fixed"
              style="right: 27.5%;top: 23.5%;"
              v-if="show==true"
              @mouseleave="show = false">
            <div class="flex align-center flex-col fs12 pointer citys bg-white"
                style="padding: 0.5rem 1.2rem;margin-top: 2.5rem;">
              <div class="color-white"
                  v-for="(item,index) in cityList"
                  :key="index"
                  @click="changeCity(item)"
                  style="padding: 0.5rem;">{{item.area}}</div>

            </div>
          </div>
            <div class="flex ls-flex ls-al-center align-center" style="border: 2px solid #eee;padding: 0 0.4rem;border-radius: 2rem;">
              <div class="flex align-center">
                <img src="../assets/search.png" alt="" style="width: 1.3rem;height: 1.3rem;">
                <el-input
                    placeholder="请输入资产名称"
                  :clearable="true"
                    v-model="input">
                </el-input>
              </div>
              <div class="">
                <div class="fs-16 bg-1 color-white flex align-center pointer"  @click="search" style="padding: 0.4rem 0.8rem;border-radius: 2rem;">搜索</div>

              </div>
            </div>
          </div>
          
        </div>
        
      </div>
    </div>
    <div class="width-full" style="height: 1px;background: #EFEFEF;"></div>
    
  </div>
  
</template>
   
<script>
export default {
	data() {
		return { 
      input:'',
      show:false
		}
	},

  created(){
    
    
  },

  methods: {
    search() {
      this.$router.push({ 
        path: '/', 
        query: { title: this.input }, 
      });
      window.location.reload(); 
    },
  },
}
</script>

<style scoped lang="scss">
.citys {
  max-height: 10rem;
  overflow-y: auto;
}
.citys::-webkit-scrollbar {
  width: 0;
  height: 0;
}
.header{
   position: sticky;
  top: 0;
  left: 0;
  z-index: 10;
  background: #fff;
}
::v-deep .el-input__inner{
  border: none !important;
  padding: 0;
}
</style>